module.exports = __webpack_public_path__ + "img/list_wx.65f1dd4b.jpg";